import React from 'react';
import { useHistory } from 'react-router-dom';

import { serverUtils } from '../../utils/serverUtils/serverUtils';

export const hooks = {
  useOnRouteChangeDispatchEvent() {
    const history = useHistory();
    const lastLocation = React.useRef(!serverUtils.isServerSide() ? {
      page_location: window.location.href,
      page_path: `${window.location.pathname}${window.location.search}`,
    } : null);

    React.useEffect(() => {
      if (!serverUtils.isServerSide() && !serverUtils.isNextBuild()) {
        return history.listen(() => {
          const newLocation = {
            page_location: window.location.href,
            page_path: `${window.location.pathname}${window.location.search}`,
          };

          if (lastLocation?.current?.page_location !== newLocation.page_location
              || lastLocation?.current.page_path !== newLocation.page_path) {
            const routeChangeEvent = new CustomEvent('routeChange', {
              detail: newLocation,
            });

            window.dispatchEvent(routeChangeEvent);
            lastLocation.current = newLocation;
          }
        });
      }
      return () => ({});
    }, [history]);
  },
};

export const PageViewEventContainer = () => {
  hooks.useOnRouteChangeDispatchEvent();
  return null;
};

PageViewEventContainer.displayName = 'PageViewEventContainer';
